import {
  List,
  Datagrid,
  TextField,
  Resource,
  SimpleShowLayout,
} from "react-admin";

// Read-only catalog of the cross-entity business rules. The rules live in backend
// code (businessRules.service.ts); this screen just surfaces their intent.
// Rows expand inline (rowClick="expand") to avoid a getOne fetch — the backend
// only exposes the list endpoint.
const RuleDetail = (props) => (
  <SimpleShowLayout {...props}>
    <TextField source="description" label="Description" />
    <TextField source="fieldKey" label="Field key" />
    <TextField source="producesGap" label="Produces gap" />
  </SimpleShowLayout>
);

const BusinessRulesCatalogList = (props) => (
  <List {...props} perPage={25} bulkActionButtons={false}>
    <div style={{ marginTop: "15px" }}>
      <Datagrid rowClick="expand" expand={<RuleDetail />}>
        <TextField source="ruleId" label="Rule" />
        <TextField source="title" label="Title" />
        <TextField source="targetEntity" label="Target entity" />
      </Datagrid>
    </div>
  </List>
);

const businessRulesCatalogResource = () => (
  <Resource
    name="businessRulesCatalog"
    options={{ label: "Business rules", menuGroup: "Bcome" }}
    list={BusinessRulesCatalogList}
  />
);

export default businessRulesCatalogResource;
